module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"modalTitle":"Download the Keap app","title":"Get the Keap mobile app to quickly import contacts","desktopTitle":"Save time importing contacts with the Keap mobile app"}}')
  delete Component.options._Ctor
}
